export default function ProjectSettings() {
    return (
        <ul>{Array.from(Array(1000), (e, i) => {
            return <li key={i}>{i}</li>
        })}</ul>
    );
}